import type { OpenAnotherMailboxDialogProps } from "./components/OpenAnotherMailboxDialog";
import type * as lazyIndex from "./lazyIndex";
import { createLazyComponent, type LazyComponent, LazyModule } from "owa-bundling";
const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule<typeof lazyIndex>(() => import("./lazyIndex"), {
    name: "common/controls/packages/controls/owa-explicit-logon",
});
export const OpenAnotherMailboxDialog: LazyComponent<OpenAnotherMailboxDialogProps, unknown, void> = createLazyComponent(lazyModule, m => m.OpenAnotherMailboxDialog);
